import { render, staticRenderFns } from "./directCopy.vue?vue&type=template&id=c1426e1e"
import script from "./directCopy.vue?vue&type=script&lang=js"
export * from "./directCopy.vue?vue&type=script&lang=js"
import style0 from "./directCopy.vue?vue&type=style&index=0&id=c1426e1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports